import { render, staticRenderFns } from "./CommonSection.vue?vue&type=template&id=e24b95f8&"
import script from "./CommonSection.vue?vue&type=script&lang=js&"
export * from "./CommonSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports